import React from 'react';
import { FlexBox, responsive } from '@vp/swan';

const ResponsiveFlexBox = responsive(FlexBox);

interface StepsContainerProps {
    children: React.ReactNode;
    isModal: boolean;
    mdStepsDirection?: 'row' | 'column';
}
export default function StepsContainer({
    children,
    isModal,
    mdStepsDirection = 'column',
}: StepsContainerProps) {
    return (
        <ResponsiveFlexBox
            flexDirection="column"
            justifyContent="space-between"
            sm={{
                flexDirection: isModal ? 'column' : 'row',
            }}
            md={{
                flexDirection: mdStepsDirection,
            }}
        >
            {children}
        </ResponsiveFlexBox>
    );
}
